var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBlueInfo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.0001 3.07001C6.17866 3.07001 3.07001 6.17866 3.07001 10.0001C3.07001 13.8216 6.17866 16.9302 10.0001 16.9302C13.8216 16.9302 16.9302 13.8216 16.9302 10.0001C16.9302 6.17866 13.8216 3.07001 10.0001 3.07001ZM10.0001 17.5002C5.86455 17.5002 2.5 14.1357 2.5 10.0001C2.5 5.86455 5.86455 2.5 10.0001 2.5C14.1357 2.5 17.5002 5.86455 17.5002 10.0001C17.5002 14.1357 14.1357 17.5002 10.0001 17.5002Z",
    fill: "#1752AF",
    stroke: "#1752AF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.0004 13.6258C9.66949 13.6258 9.40039 13.3567 9.40039 13.0258C9.40039 12.6949 9.66949 12.4258 10.0004 12.4258C10.3313 12.4258 10.6004 12.6949 10.6004 13.0258C10.6004 13.3567 10.3313 13.6258 10.0004 13.6258Z",
    fill: "#1752AF",
    stroke: "#1752AF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.7002 11.2247V7.02461C9.7002 6.85901 9.8343 6.72461 10.0002 6.72461C10.1661 6.72461 10.3002 6.85901 10.3002 7.02461V11.2247C10.3002 11.3903 10.1661 11.5247 10.0002 11.5247C9.8343 11.5247 9.7002 11.3903 9.7002 11.2247Z",
    fill: "#1752AF",
    stroke: "#1752AF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlueInfo);
export default __webpack_public_path__ + "static/media/BlueInfo.31f057a93a084d1ef6b6fcd8b420faf6.svg";
export { ForwardRef as ReactComponent };